import { Close } from '@mui/icons-material'
import { Button, SxProps, Theme, Typography, useTheme } from '@mui/material'
import { ComponentProps } from 'react'

import getButtonStyles, {
  BUTTON_TEXT_STYLES,
} from '~/components/createEdit/utils'

type TProps = {
  label?: string
  labelSx?: SxProps<Theme>
} & Omit<ComponentProps<typeof Button>, 'children'>

function CancelButton({
  label = 'Cancel',
  sx = {},
  labelSx = {},
  ...props
}: TProps) {
  const theme = useTheme()

  return (
    <Button
      startIcon={<Close />}
      variant="secondary"
      sx={{ ...getButtonStyles(theme), ...sx } as SxProps<Theme>}
      {...props}
    >
      <Typography
        variant="h4"
        sx={{ ...BUTTON_TEXT_STYLES, ...labelSx } as SxProps<Theme>}
      >
        {label}
      </Typography>
    </Button>
  )
}

export default CancelButton
